import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import constants from 'constants/constants'
import { RootState } from 'store'

const contextualHelpSlice = createSlice({
    name: 'contextualHelp',
    initialState: {
        showHelpBar: false,
        contextualHelpUrl: ''
    },
    reducers: {
        toggleShowHelpBar: (state, { payload }: PayloadAction<string>) => {
            state.showHelpBar = !state.showHelpBar
            state.contextualHelpUrl = payload || ''
        },
    }
})

const languageMapper = {
    'en-US': '',
    'nl-NL': 'nl/',
    'de-DE': 'de/'
}

export const showHelpBarSelector = (state: RootState) => state.contextualHelp.showHelpBar
export const contextualHelpUrlSelector = (state: RootState) => {
    const eventLanguage = state.eventPreview?.eventData?.language
    const url = state.contextualHelp.contextualHelpUrl.replace(
        constants.contextualHelpBaseUrl, `${constants.contextualHelpBaseUrl}${languageMapper[eventLanguage]}`
    )
    return url
}

export const toggleShowHelpBar = contextualHelpSlice.actions.toggleShowHelpBar

export default contextualHelpSlice.reducer
